import React from 'react';
import {
  Paper,
  Typography,
  CircularProgress
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { useFetchFieldsDetails } from 'api/dashboardMaintenanceEnquiry/dashboardMaintenanceEnquiry';
import { IFieldsWidgetProperties } from './FieldsWidget.properties';
import { getFieldValues, getKeyId } from './FieldsWidget.utils';
import { ELEVATION_LEVEL, FINAL_SEQUENCE_NUMBER } from './FieldsWidget.constants';
import { fieldsWidgetStyles } from './FieldsWidget.styles';
import { RenderFieldValue } from './FieldsWidget.components';
import classNames from 'classnames';

const FieldsWidget = ({ classes, schema, ...props }: IFieldsWidgetProperties) => {
  const KeyId = getKeyId(props);
  const { data: dataSet, isFetching } = useFetchFieldsDetails(schema?.DashboardId, KeyId);
  const Fields = dataSet?.DashboardData?.Widgets.filter((obj) => obj?.DashWidgetId?.Value === schema?.DashboardWidgetId)?.[0]?.Fields?.sort((a, b) => a?.Sequence?.Value - b?.Sequence?.Value);
  const sequencedFields = Fields?.map((obj) => {

    return {
      label: obj?.FieldName?.Value,
      sequence: obj?.FieldDataType?.Value === 'button' ? schema?.widgetType?.size === 'Landscape' ? obj?.Sequence?.Value : (Fields?.length + FINAL_SEQUENCE_NUMBER) : obj?.Sequence?.Value,
      fieldValues: getFieldValues(obj)
    };
  })?.sort((a, b) => a?.sequence - b?.sequence);
  const isLandscape = schema?.widgetType?.size === 'Landscape';

  if (!KeyId || !sequencedFields || sequencedFields?.length === 0) return null;

  return (
    <div className={classes.paperContainer}>
      <Paper className={`${classes.paper} ${isLandscape ? classes.landscape : classes.portrait}`}
        elevation={ELEVATION_LEVEL}>
        {
          schema?.WidgetTitle &&
          <Typography variant='h6'>
            <div
              className={classes.widgetTitle}
              style={{ width: `calc(100% - ${isLandscape ? '3.3px' : '1px'})` }}
            >
              {schema?.WidgetTitle}
            </div>
          </Typography>
        }
        {isFetching ? (
          <CircularProgress />
        ) : isLandscape ? (
          <div className={classes.fieldsContainer}>
            <div className={classes.row}>
              {sequencedFields?.map((field, i) => {
                const isFullWidthButton =
                  field.fieldValues?.[0]?.type === 'Button' && !!(field.fieldValues?.[0]?.link);

                return (
                  <div key={i} className={classes.fieldCell}>
                    {
                      isFullWidthButton ? (<>
                        <div className={classNames(classes.value, classes.fullWidthButton)}>
                          <Typography className={classes.cellContent}>
                            <RenderFieldValue obj={field?.fieldValues[0]} props={props} />
                          </Typography>
                        </div>
                      </>) :
                        (
                          <>
                            <div className={classes.label}>
                              <Typography className={classes.cellContent}>{field.label}</Typography>
                            </div>
                            <div className={classes.value}>
                              <Typography className={classes.cellContent}>
                                <div className={classes.valueContainer}>
                                  {field?.fieldValues?.map((obj) => (<RenderFieldValue obj={obj} props={props} />))}
                                </div>
                              </Typography>
                            </div>
                          </>)
                    }
                  </div>
                );
              })}
            </div>
          </div>
        ) : (
          <div className={classes.fieldsContainer}>
            {sequencedFields?.map((field, i) => {
              const isFullWidthButton =
                field.fieldValues?.[0]?.type === 'Button' && !!(field.fieldValues?.[0]?.link);

              return (
                <div key={i} className={classNames(classes.row, classes.potraitContainer)}>
                  {isFullWidthButton ? (
                    <div className={classNames(classes.value, classes.fullWidthButton)}>
                      <Typography className={classes.cellContent}>
                        <RenderFieldValue obj={field?.fieldValues[0]} props={props} />
                      </Typography>
                    </div>
                  ) : (
                    <>
                      <div className={classes.label} style={{ height: 'auto' }}>
                        <Typography className={classes.cellContent}>{field.label}</Typography>
                      </div>
                      <div className={classes.value} style={{ height: 'unset' }}>
                        <Typography className={classes.cellContent}>
                          <div className={classes.valueContainer}>
                            {field?.fieldValues?.map((obj) => (<RenderFieldValue obj={obj} props={props} />))}
                          </div>
                        </Typography>
                      </div>
                    </>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </Paper>
    </div>
  );
};

export default withStyles(fieldsWidgetStyles)(FieldsWidget);
